const currentSection = (state, action) => {
  if (state.currentSection) {
    return state.currentSection;
  }

  const { materials } = action.payload;
  const firstSection = materials.find((material) => !material.isFolder);
  if (firstSection) {
    return firstSection.id;
  }

  return null;
};

const fetch = (state, action) => {
  switch (action.status) {
    case 'started':
      return { ...state, isFetchingSections: true, isErrored: false };
    case 'success':
      return {
        ...state,
        hasFetchedSections: true,
        isFetchingSections: false,
        isErrored: false,
        currentSection: currentSection(state, action),
      };
    case 'error':
      return {
        ...state,
        hasFetchedSections: false,
        isFetchingSections: false,
        isErrored: true,
      };
    default:
      return state;
  }
};

export default fetch;
